export enum ContactType {
    EMAIL = 'EMAIL',
    MOBILE = 'MOBILE'
}